import Component from "vue-class-component";
import Vue from "vue";

@Component
export class HideOnScrollMix extends Vue {
    beforeMount() {
        const scrollr = document.querySelector('.layout ') as HTMLElement;
        scrollr.addEventListener('scroll', this.handleWindowScroll);
    }

    beforeDestroy() {
        const scrollr = document.querySelector('.layout ') as HTMLElement;
        scrollr.removeEventListener('scroll', this.handleWindowScroll);
    }

    handleWindowScroll() {
        console.log('handleWindowScroll')
        const calendarElements = document.querySelectorAll('.ant-calendar-picker-container') as NodeListOf<HTMLElement>;
        const timeElements = document.querySelectorAll('.ant-time-picker-panel') as NodeListOf<HTMLElement>;

        calendarElements.forEach(element => {
            const existingStyle = element.getAttribute('style');
            if (!existingStyle || !existingStyle.includes('display')) {
                element.style.display = 'none';
            }
        });

        timeElements.forEach(element => {
            const existingStyle = element.getAttribute('style');
            if (!existingStyle || !existingStyle.includes('display')) {
                element.style.display = 'none';
            }
        });
    }
}